import React, { useState } from 'react';
import Header from '../../sections/Header';
import Banner from '../../sections/Banner';
import Footer from '../../sections/Footer';
import SectionHeader from '../../composites/SectionHeader';
import Breadcrumbs from '../../sections/Breadcrumbs';

const devPlatformFeatures = [
  {
    title: 'Enterprise AI Stack',
    description: 'Access a complete enterprise-grade AI development environment with all the tools you need to build, test, and deploy AI solutions.'
  },
  {
            title: 'AI Lab App',
    description: 'Use our flagship responsive Claude-style AI platform for experimenting with LLM models, private models, knowledge storage, and media generation.'
  },
  {
    title: 'Full Lifecycle Development',
    description: 'Get hands-on experience with the complete Gen-AI product development lifecycle, including DevOps, engineering, and QA processes.'
  },
  {
    title: 'Real-World Training',
    description: 'Complete generalist training programs with real-world exercises that will run over the next six months to supercharge your AI skills.'
  },
  {
    title: 'Knowledge Management',
    description: 'Experiment with advanced knowledge storage and retrieval systems, memory management, and intelligent data processing capabilities.'
  },
  {
    title: 'Media Generation',
    description: 'Explore cutting-edge media generation tools and techniques for creating AI-powered content and visual assets.'
  }
];

const InitiativeTwo: React.FC = () => {

  return (
  <>
    <Banner
              header={<Header />}
      breadcrumbs={<Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Initiatives', href: '/initiatives' }, { label: 'ie-ai Dev Platform' }]} />}
      title={<span className="flex items-center">ie-ai Dev Platform <span className="inline-block rounded-full bg-teal-200 text-teal-700 text-sm font-semibold px-2 py-1 align-middle">Coming soon</span></span>}
      subtitle="The ie-ai Dev Platform is an Enterprise-grade full AI stack, where you all have the opportunity to supercharge your AI skills."
      colorVariant="gradient"
      imageVariant="withImage"
      paddingVariant="default"
      showCTAs={false}
      showDefaultGraphic={true}
      videoCaption="Watch a demonstration of the ie-ai Dev Platform in action"
      icon={
        <div style={{ position: 'relative', width: '100%', aspectRatio: '16/9', background: '#000', overflow: 'hidden', borderRadius: 12 }}>
          <video
            src="/video/IECompanion.mov"
            controls={true}
            poster="/video/thumbnail.png"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', background: '#000' }}
            aria-label="ie-ai Dev Platform demonstration video"
          >
            Sorry, your browser does not support embedded videos.
          </video>
        </div>
      }
    />
    <div className="max-w-7xl mx-auto px-4 py-12">
      <SectionHeader
        heading="Platform Features"
        description="Explore the key features and capabilities of the ie-ai Dev Platform that will help you supercharge your AI development skills."
        className="mb-2"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {devPlatformFeatures.map((feature, idx) => (
          <div key={feature.title} className="bg-white rounded-xl shadow-sm border border-gray-100 flex flex-col items-left p-6 text-left h-full">
            <h3 className="text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
            <p className="text-gray-700 text-base leading-relaxed">{feature.description}</p>
          </div>
        ))}
      </div>
      <div className="mt-12 p-6 bg-gray-50 rounded-lg text-left border border-gray-100 shadow-sm">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">More Content Coming Soon</h3>
        <p className="text-gray-600 mb-2">
          We're continuously building out the ie-ai Dev Platform with new features, training modules, and development tools. Check back regularly for updates!
        </p>
      </div>
    </div>
    <Footer />
  </>
  );
};

export default InitiativeTwo; 